import { Flex, Text, Tag, Spacer } from "@chakra-ui/react";
import { BiCheckboxChecked } from "react-icons/bi";
import CardDefault from "ui/components/Cards/CardDefault";

function FinanceiroTab() {
  return (
    <>
      <Flex>
        <Flex flexDir="row" gap="27px" w="100%">
          <CardDefault>
            <Flex flexDir="column" fontFamily="Poppins" fontWeight="400" fontSize="16px" color="#52575C" lineHeight="24px" mb="12px">
              <Text fontWeight="500" fontSize="20px" mb="22px" color="black">Dados</Text>
              <Text>Nome: Lorem ipsum dolor Sit Amet</Text>
              <Text>CPF/CNPJ: 000.000.000-00</Text>
              <Flex mt="40px">
                <Flex flexDir="column" mr="32px">
                  <Text fontWeight="500" fontSize="20px" mb="20px" color="black">Tipo</Text>
                  <Text>E-mail</Text>
                  <Text>Celular</Text>
                  <Text>Fax</Text>
                </Flex>
                <Flex flexDir="column">
                  <Text fontWeight="500" fontSize="20px" mb="20px" color="black">Contato</Text>
                  <Text>email.email@email.com</Text>
                  <Text>(00) 00000-0000</Text>
                  <Text>(00) 00000-0000</Text>
                </Flex>
              </Flex>
            </Flex>
          </CardDefault>
          <CardDefault w="80%">
            <Flex flexDir="column" fontFamily="Poppins" fontWeight="400" fontSize="16px" color="#52575C" lineHeight="24px" mb="12px">
              <Flex>
                <Text fontWeight="500" fontSize="20px" mb="22px" color="black">Plano Para Administradoras</Text>
                <Spacer />
                <Tag
                  w="72px"
                  h="27px"
                  variant="outline"
                  colorScheme="gray"
                  borderRadius="20px"
                  justifyContent="center"
                  fontWeight="400"
                >Mensal</Tag>
              </Flex>
              <Text textAlign="left" mb="40px">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
              </Text>
              <Flex>
                <Flex flexDir="column" fontSize="14px" lineHeight="21px">
                  <Flex alignItems="center" gap="10px">
                    <BiCheckboxChecked fontSize="20px" color="#38A169"></BiCheckboxChecked>
                    <Text>CRM de cobranças</Text>
                  </Flex>
                  <Flex alignItems="center" gap="10px">
                    <BiCheckboxChecked fontSize="20px" color="#38A169"></BiCheckboxChecked>
                    <Text>Gestão de Compras</Text>
                  </Flex>
                  <Flex alignItems="center" gap="10px">
                    <BiCheckboxChecked fontSize="20px" color="#38A169"></BiCheckboxChecked>
                    <Text>Reserva de áreas comuns</Text>
                  </Flex>
                </Flex>
                <Spacer />
                <Flex alignItems="end" >
                  <Text>R$ 209,90/mês</Text>
                </Flex>
              </Flex>
            </Flex>
          </CardDefault>
        </Flex>      
      </Flex>  
      <Flex mt={4}>
        <CardDefault w="100%">
          <Flex flexDir="column" fontFamily="Poppins" fontWeight="400" fontSize="16px" color="#52575C" lineHeight="24px">
            <Text fontWeight="500" fontSize="20px" color="black">Histórico de Pagamento</Text>
          </Flex>
        </CardDefault>
      </Flex>
    </>
  );
}

export default FinanceiroTab;
